import * as React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import { StyledOkDialog } from "../../containers/dashboard/components/feedback/feedback.styles";
import { StyledDiv } from "src/app/admin/components/confirmPopupModel/confirmpopup.styles";
import { StyledDialogTitle } from "../layout/styles";

export function ConfirmDialog({open, title, confirmText, onCancel = null, onOK, 
  cancelButtonText = 'Cancel', okButtonText='Delete',
  customUi = <></>
}) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText dangerouslySetInnerHTML={{__html: confirmText}}></DialogContentText>
        {customUi}
      </DialogContent>
      <DialogActions>
        {
          onCancel && <Button onClick={onCancel} color="primary" variant="outlined">
            {cancelButtonText}
          </Button>
        }
        <Button onClick={onOK} color="secondary" variant="outlined">
          {okButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export type PopUpProps = {
    open: boolean,
    title: any,
    body: any,
    onOk: React.MouseEventHandler<HTMLSpanElement>,
    maxWidth: any;
};

export const OkPopupModel = ({open, title, body, onOk, maxWidth}: PopUpProps) => {
  return (
    <StyledOkDialog open={open} maxWidth={maxWidth} scroll={'paper'} fullWidth={true}>
      <div style={{ overflow: 'hidden',display: 'flex',flexDirection: 'column'}}>
        
        <div style={{backgroundColor: "orange"}}>
            <StyledDialogTitle>
            <div style={{display:"flex", gap: "412px"}}>
              <div style={{display:"flex", alignItems: 'center'}}>
                  <span style={{color: 'white'}}>{title}</span>
              </div>
            </div>
            </StyledDialogTitle>
        </div>

        <div style={{padding:'25px 45px 0px 45px', display:"flex", flexDirection:"column"}}>
          {body}
        </div>
    
        <StyledDiv style={{display:'flex',padding: '25px 0px 30px 0px', justifyContent: 'center', gap: '15px'}}>
          <Button color="primary" onClick={onOk}>OK</Button>
        </StyledDiv>
    
      </div>
    </StyledOkDialog>
  )
};
